<template>
  <div class="select-competition-modal modal">
    <div class="modal-inner">
      <div class="modal-content" v-if="!perfectCompanyModal">
        <div class="title">
          <p class="h3">申报大赛选择</p>
          <p class="close" @click="close"></p>
        </div>
        <div class="content">
          <ul class="competition-list">
            <li class="item" v-for="(item, index) in competitionInfo" :key="index" @click="isInfoPerfect(index)">
              <div class="img">
                <img :src="item.imageUrl + '?' + time" alt="competitionLogo">
              </div>
              <div class="btns">
                <Button class="btn" :class="{disable: !item.releaseContest}">{{item.releaseContest?'立即申报':'暂未开启'}}</Button>
                <!-- <p v-else>暂未开始</p> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "select-competition",
  data () {
    return {
      time: new Date().getTime(),
      language: "",
      userInfo: null,
      perfectCompanyModal: false,
      competitionInfo: null
    }
  },
  watch: {
    "$store.state.userInfo": function(){
      this.userInfo = this.$store.state.userInfo;
    },
    "$store.state.language": function(){
      this.language = this.$store.state.language;
    }
  },
  created () {
    this.language = this.$store.state.language;
    this.userInfo = this.$store.state.userInfo;
    this.getCompetitionInfo();
  },
  methods: {
    getCompetitionInfo(){
      // this.competitionInfo = competitionInfo.data
      // this.$store.commit("setCompetitionList", competitionInfo.data);
      // console.log(12312, competitionInfo.data)

      let that = this;
      that.api("test3/api/Declare/ContestList",{},"get").then(function(res){
        if(res.data.success){
          // res.data.data[1].status = 1;
          that.competitionInfo = res.data.data
          that.$store.commit("setCompetitionList", res.data.data)
        }
      })
    },
    isInfoPerfect(index){
      if(!this.userInfo.isInfoPerfect){
        this.$store.commit("setPerfectCompanyInfoModal", true)
        this.$store.commit("setCompetitionListModal", false)
      }else{
        this.selectCompetition(index);
      }
    },
    selectCompetition(index){
      let releaseContest = this.competitionInfo[index].releaseContest;
      if(!releaseContest){
        return;
      }
      let path;
      // console.log(this.language)
      if(this.language === "cn"){
        path = "/competition/declare"
      }else{
        path = "/en/competition/declare"
      }
      if(this.competitionInfo[index].status){
        if(this.$route.name === "competition-declare"){
          this.$router.replace({
            path: "/refresh",
            query: {
              url: path,
              cid: releaseContest.id,
              sid: releaseContest.seasonId
            }
          })
        }else{
          this.$router.push({
            path: path,
            query: {
              cid: releaseContest.id,
              sid: releaseContest.seasonId
            }
          })
        }
      }
    },
    close(){
      this.$store.commit("setCompetitionListModal", false);
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-inner{
    display: table-cell;
    vertical-align: middle;
  }
  .modal-content{
    width: 750px;
    height: 314px;
    margin: 0 auto;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;
    .title{
      height: 56px;
      line-height: 56px;
      position: relative;
      padding: 0 20px;
      .close{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 10px;
        height: 10px;
        right: 20px;
        margin: auto;
        color: #919EAB;
        cursor: pointer;
        background: url(https://cdn.fabricschina.com.cn/statics/pattern-design/icon/close.png) no-repeat 0 0/100% 100%;
      }
      .h3{
        text-align: left;
        font-weight: 500;
        span{
          color: #C0C5CA;
          font-size: 14px;
          padding-left: 15px;
          font-weight: 300;
        }
      }
    }
    .content{
      min-height: 50px;
      border-top: 1px solid #e8e8e8;
      padding: 36px 44px;
      height: 258px;
      .competition-list{
        display: flex;
        justify-content: space-between;
        .item{
          width: 186px;
          height: 186px;
          border: 1px solid #fff;
          background-color: rgba($color: #000000, $alpha: 0.5);
          border-radius: 4px;
          position: relative;
          overflow: hidden;
          .img{
            width: 100%;
            height: 100%;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .btns{
            color: #fff;
            position: absolute;
            width: 100%;
            bottom: 10px;
            z-index: 1;
          }
        }
        .item:hover{
          border: 1px solid rgb(92, 153, 245);
        }
      }
      .btn{
        border-radius: 15px!important;
        height: 26px!important;
        line-height: 24px!important;
        border: none!important;
      }
      .disable{
        background: #eaeaea!important;
        color: #999;
      }
    }
  }
</style>